var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var AbstractToolController = editor_2d.AbstractToolController;
var PropertyToolStateMachine = require("./propertyToolStateMachine.js");

var PropertyToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        font: "Verdana",
        fontSize: 10,
        strokeWidth: 2
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(PropertyToolController, AbstractToolController);
PropertyToolController.inject = AbstractToolController.inject;
PropertyToolController.StateMachineClass = PropertyToolStateMachine;

module.exports = PropertyToolController;

PropertyToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: '<Property',
        title: 'Property',
        style: {
            icon: 'icon-text.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
